import { useSyncExternalStore } from 'react';

export type NavLayout = 'sidebar' | 'topnav';
const KEY = 'st.nav.layout';

/**
 * App-wide navigation layout preference (Left Sidebar vs Top Navigation). A provider-free external store backed by
 * localStorage so it persists across reloads and instantly re-renders every consumer (AppLayout, Topbar, settings)
 * when changed — no route/page change, no duplicate global state.
 */
function read(): NavLayout {
  try { return (window.localStorage.getItem(KEY) as NavLayout) === 'topnav' ? 'topnav' : 'sidebar'; } catch { return 'sidebar'; }
}

let current: NavLayout = read();
const listeners = new Set<() => void>();

export function setNavLayout(layout: NavLayout) {
  current = layout;
  try { window.localStorage.setItem(KEY, layout); } catch { /* ignore */ }
  listeners.forEach((l) => l());
}

function subscribe(cb: () => void) { listeners.add(cb); return () => { listeners.delete(cb); }; }
function getSnapshot(): NavLayout { return current; }

export function useNavLayout() {
  const layout = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
  return { layout, setLayout: setNavLayout };
}
